export const FETCH_ALLSUBJECT_REQUEST = 'FETCH_ALLSUBJECT_REQUEST'
export const FETCH_ALLSUBJECT_SUCCESS = 'FETCH_ALLSUBJECT_SUCCESS'
export const FETCH_ALLSUBJECT_FALIURE = 'FETCH_ALLSUBJECT_FALIURE'
